import { useQuery } from "@tanstack/react-query";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";

type MediaItem = { id: string; source_page_url: string; source_image_url: string; source_domain: string | null };

export function ApprovedBusinessMedia({ businessId }: { businessId: string }) {
  const { data } = useQuery({
    queryKey: ["approved-business-media", businessId],
    queryFn: async () => {
      const response = await fetch(`/api/businesses/${encodeURIComponent(businessId)}/media`);
      if (!response.ok) return { items: [] as MediaItem[] };
      return response.json() as Promise<{ items: MediaItem[] }>;
    },
  });
  if (!data?.items?.length) return null;
  return <Card><CardHeader><CardTitle>업체 제공·승인 사진</CardTitle><CardDescription>업체주가 사용 권한을 확인하고 OZK 검수를 통과한 이미지입니다.</CardDescription></CardHeader><CardContent><div className="grid gap-3 sm:grid-cols-2">{data.items.map((item) => <a key={item.id} href={item.source_page_url} target="_blank" rel="noreferrer" className="overflow-hidden rounded-lg border"><img src={item.source_image_url} alt="업체 승인 이미지" className="h-48 w-full object-cover" loading="lazy" /><div className="p-2 text-xs text-muted-foreground">출처: {item.source_domain || "업체 제공"}</div></a>)}</div></CardContent></Card>;
}
